import classNames from 'classnames';
import './TileItem.scss';

export type ItemPositionType =
  | 'top-left'
  | 'top-center'
  | 'top-right'
  | 'middle-left'
  | 'middle-center'
  | 'middle-right'
  | 'bottom-left'
  | 'bottom-center'
  | 'bottom-right';

export interface TileItemProps {
  children: React.ReactNode;
  padding?: 'none' | 'xs' | 'small' | 'medium' | 'large' | 'xl';
  position?: ItemPositionType;
  className?: string;
}

/**
 * TileItem Component
 * @param position - Position of the component.
 * @param padding - Padding of the component.
 * @param children - Any React.ReactNode element.
 * @param className - Additional className to extend its style.
 */
export const TileItem: React.FC<TileItemProps> = ({
  children,
  position = 'top-right',
  padding,
  className,
  ...rest
}) => {
  return (
    <div
      className={classNames(
        'vds-tile-item',
        {
          [`vds-tile-item--${position}`]: position,
          [`vds-tile-item--padding-${padding}`]: padding,
        },
        className,
      )}
      {...rest}>
      {children}
    </div>
  );
};
